import { useMemo } from "react"

import { useSessionBookingsQuery } from "../../../networking/sessions/queries"

export const useLateCancelSessionsCount = () => {
  const { data: bookings } = useSessionBookingsQuery()
  const lateCancelCount = useMemo(
    () =>
      bookings?.filter((booking) => booking.marked_late_cancellation).length,
    [bookings]
  )
  return lateCancelCount || 0
}

export default useLateCancelSessionsCount
